import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex flex-col gap-4">
        <h3 className="text-2xl text-red-500">404 page not found</h3>
        <button
          onClick={handleBack}
          className="flex items-center justify-center rounded-lg bg-black px-4 py-2 text-center text-sm font-medium text-white"
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
